// js
import React from 'react';
import PropTypes from 'prop-types';
import DSATabLink from './DSATabLink';
import DSATabDropdown from './DSATabDropdown';


const DSATab = ({pathname, name, title, subLinks, showExtensions, baseNavRoute}) => {

  return (
    <li key={name} className='dropdown'>
      <DSATabLink
        baseNavRoute={baseNavRoute}
        pathname={pathname}
        name={name}
        title={title}
      />
      <DSATabDropdown
        baseNavRoute={baseNavRoute}
        subLinks={subLinks}
        showExtensions={showExtensions}
        name={name}
      />
    </li>
  );
};

DSATab.propTypes = {
  pathname: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subLinks: PropTypes.array.isRequired,
  showExtensions: PropTypes.bool,
  baseNavRoute: PropTypes.string.isRequired
};

export default DSATab;



// WEBPACK FOOTER //
// ./src/components/DSATab.js